import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tileLayer } from 'leaflet';

export const baseTiles = {

  'Open Street Map': tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 5,
    noWrap: true,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }),
  'CartoDB Light': tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 3,
    noWrap: true,
  }),
  'CartoDB Dark': tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 3,
    noWrap: true,
  }),
  'MapBox Streets': tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + environment.mapBoxToken, {
    maxZoom: 22,
    minZoom: 5,
    noWrap: true,
    id: 'mapbox/streets-v11',
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
  }),
  'MapBox Satellite': tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + environment.mapBoxToken, {
    maxZoom: 22,
    minZoom: 5,
    noWrap: true,
    id: 'mapbox/satellite-v9',
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
  }),
  'Google Hybrid': tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    minZoom: 5,
    noWrap: true,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
  })
}

export interface MapStatus {
  baseLayer: keyof typeof baseTiles;
  center: { lat: number, lng: number } | [number, number];
  zoom: number;
  overlay: { [key: string]: boolean }
}

@Injectable({
  providedIn: 'root'
})
export class MapService {
  currentStatus: MapStatus;
  constructor(
    private http: HttpClient
  ) {
    let obj: any = {
      baseLayer: 'Open Street Map',
      center: [41.897710, 12.493106],
      zoom: 8,
      noWrap: true,
      overlay: {}
    };
    // let s = localStorage.getItem('gp-map-status');
    // if (s) {
    //   obj = Object.assign({}, obj, JSON.parse(s));
    // }
    this.currentStatus = new Proxy(obj, {
      set: (t, p, v) => {
        t[p] = v;
        // localStorage.setItem('gp-map-status', JSON.stringify(t));
        return true;
      },
      get: (t, p) => {
        return t[p];
      }
    });
  }
}
